<script lang="ts">
  import { page } from '$app/stores'
  import type { CityCampaign } from '$lib/types/campaign'
  import type { Language } from '@bond/components'
  import { utils } from '$lib/utils'

  export let campaign: CityCampaign
  $: lang = $page.params.lang as Language
  $: localeRoute = utils.getRoute(lang)
</script>

<a href={localeRoute(campaign.href || '/membership')}>
  <p>
    {#if campaign.text}
      {campaign.text}
      {#if campaign.code}
        <strong>{campaign.code}</strong>
      {/if}
    {:else if campaign.preText && campaign.postText}
      {campaign.preText}
      {#if campaign.code}
        <strong>{campaign.code}</strong>{/if}{campaign.postText}
    {/if}
  </p>
</a>

<style lang="scss">
  @use '@bond/assets/css/breakpoints';

  a {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    min-height: 4em;
    padding: 1em;
    background-color: var(--color-tertiary);
    color: var(--color-on-tertiary);
    text-decoration: none;

    @media screen and (max-width: breakpoints.$breakpoint-sm) {
      padding: 0 1em;
    }
  }
</style>
